import React from "react";
import CustomerSegmentation from "../components/Organisation/CustomerSegmentation";
import { useAuth } from "../hooks/useAuth";

const SegmentationFieldsPage: React.FunctionComponent = () => {
    const { user } = useAuth();
    const organisationId = user?.organisation?.id;
    if (!organisationId) return null;
    return <CustomerSegmentation organisationId={organisationId} />;
};

export default SegmentationFieldsPage;
